import type { AppPageTab } from '@/components/shell/AppPage/app-page-types'

/** Every level-3 tab bar in the app, keyed by place; each takes `t()` and returns the tabs in fixed order. */
export function inboxTabs(t: (key: string) => string): AppPageTab[] {
  return [
    { id: 'inbox', label: t('tabs.inbox'), to: { name: 'inbox' } },
    { id: 'inbox-sent', label: t('tabs.sent'), to: { name: 'inbox-sent' } },
    { id: 'inbox-archive', label: t('tabs.archive'), to: { name: 'inbox-archive' } },
  ]
}

export function strategyTabs(t: (key: string) => string): AppPageTab[] {
  return [{ id: 'strategy', label: t('nav.arguments'), to: { name: 'strategy' } }]
}

export function topicTabs(t: (key: string) => string, topicId: string): AppPageTab[] {
  return [
    { id: 'topic', label: t('nav.pages'), to: { name: 'topic', params: { id: topicId } } },
    {
      id: 'topic-research',
      label: t('nav.research'),
      to: { name: 'topic-research', params: { id: topicId } },
    },
  ]
}

export function mediaTabs(t: (key: string) => string): AppPageTab[] {
  return [
    { id: 'media-uploads', label: t('media.uploads'), to: { name: 'media-uploads' } },
    { id: 'media-designs', label: t('media.designs'), to: { name: 'media-designs' } },
    { id: 'media-templates', label: t('media.templates'), to: { name: 'media-templates' } },
  ]
}

export function visibilityTabs(t: (key: string) => string): AppPageTab[] {
  return [
    { id: 'visibility', label: t('tabs.rankings'), to: { name: 'visibility' } },
    {
      id: 'visibility-ai-answers',
      label: t('tabs.aiAnswers'),
      to: { name: 'visibility-ai-answers' },
    },
    {
      id: 'visibility-social-media',
      label: t('tabs.socialMedia'),
      to: { name: 'visibility-social-media' },
    },
  ]
}

export function identityTabs(t: (key: string) => string): AppPageTab[] {
  return [
    {
      id: 'identity-brand-facts',
      label: t('tabs.brandFacts'),
      to: { name: 'identity-brand-facts' },
    },
    {
      id: 'identity-customer-profile',
      label: t('tabs.customerProfile'),
      to: { name: 'identity-customer-profile' },
    },
  ]
}

export function styleTabs(t: (key: string) => string): AppPageTab[] {
  return [
    { id: 'style-voice', label: t('nav.voice'), to: { name: 'style-voice' } },
    { id: 'style-look', label: t('nav.look'), to: { name: 'style-look' } },
  ]
}

export function settingsTabs(t: (key: string) => string): AppPageTab[] {
  return [
    { id: 'settings-account', label: t('tabs.account'), to: { name: 'settings-account' } },
    { id: 'settings-billing', label: t('tabs.billing'), to: { name: 'settings-billing' } },
    {
      id: 'settings-connections',
      label: t('brand.connections.title'),
      to: { name: 'settings-connections' },
    },
  ]
}
